import { template as template_6e9234a99ded4f43b7420a5ffea556ef } from "@ember/template-compiler";
import Component from '@glimmer/component';
import BsForm from 'eflex/components/bs-form';
import AddButton from 'eflex/components/add-button';
import TrashCan from 'eflex/components/trash-can';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import { fn } from '@ember/helper';
import { isEmpty } from '@ember/utils';
const selectedMaterialValueTemplate = template_6e9234a99ded4f43b7420a5ffea556ef(`
<span title={{@option.partNumber}} class="w-100">
  {{#if @option.partDescription}}
    {{@option.partNumber}} - {{@option.partDescription}}
  {{/if}}
</span>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default class KineticMaterialConfig extends Component {
    @service
    store;
    @service
    kineticRepo;
    addMaterial = ()=>{
        const material = this.store.createRecord('kinetic-operation-material', {});
        this.args.task.materials = [
            ...this.args.task.materials,
            material
        ];
    };
    updateMaterial = (materialRow, selectedMaterial)=>{
        const task = this.args.task;
        const currentMaterial = this.store.peekRecord('kinetic-operation-material', selectedMaterial.id);
        task.materials = task.materials.map((row)=>(row === materialRow ? currentMaterial : row));
    };
    deleteMaterial = (materialRow)=>{
        const task = this.args.task;
        task.materials = task.materials.filter((m)=>m !== materialRow);
    };
    get isAddDisbaled() {
        return isEmpty(this.options);
    }
    get options() {
        const kineticOperationMaterials = this.args.task?.parent?.materials;
        const taskMaterials = this.args.task?.materials ?? [];
        return kineticOperationMaterials.filter((material)=>!taskMaterials.some((m)=>m.id === material.id));
    }
    static{
        template_6e9234a99ded4f43b7420a5ffea556ef(`
    <div class="kinetic-material-config">
      <div class="col bootstrap-table main-overflow h-100" ...attributes>
        <BsForm
          @model={{this}}
          @disabled={{@disabled}}
          @showValidations={{@showValidations}}
        as |form|>
          <div class="row form-row header-row px-2">
            <div class="col-2">
              {{t "kinetic.sequence"}}
            </div>
            <div class="col-6">
              {{t "kinetic.material.part"}}
            </div>
            <div class="col-2">
              {{t "kinetic.material.quantityPer"}}
            </div>
            <div class="col-icon border-0" />
          </div>
          {{#each @task.materials as |material|}}
            <div class="row form-row px-2">
              <div class="col-2 material-sequence">{{material.sequence}}</div>
              <div class="col-6">
                <form.element
                  class="material-part-select"
                  @controlType="power-select"
                  @options={{this.options}}
                  @value={{material}}
                  @onChange={{fn this.updateMaterial material}}
                as |el|>
                  <el.control
                    @triggerClass="form-control form-control-sm"
                    @searchField="partNumber"
                    @selectedItemComponent={{selectedMaterialValueTemplate}}
                  as |option|>
                    {{option.partNumber}} - {{option.partDescription}}
                  </el.control>
                </form.element>
              </div>
              <div class="col-2 material-quantity-per">{{material.quantityPer}}</div>
              <div class="col-icon mb-2">
                <TrashCan
                  class='delete-material'
                  disabled={{@disabled}}
                  @onDelete={{fn this.deleteMaterial material}}
                />
              </div>
            </div>
          {{/each}}
        </BsForm>
      </div>
      <AddButton
        class="add-material"
        @disabled={{this.isAddDisbaled}}
        @onClick={{this.addMaterial}}
      >
        {{t 'plant.task.material'}}
      </AddButton>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
